interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  actionText?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-archive-line",
  title,
  desc,
  actionText,
  onAction
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-500">
        <i className={`${icon} text-3xl`}></i>
      </div>
      <h3 className="font-heading text-lg text-foreground-900">{title}</h3>
      {desc && <p className="mt-2 max-w-md text-sm text-foreground-600">{desc}</p>}
      {actionText && onAction && (
        <button
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
        >
          <i className="ri-refresh-line"></i>
          {actionText}
        </button>
      )}
    </div>
  );
}